export const MaritalStatus = [
  {
    label: 'Single',
    value: 'Single'
  },
  {
    label: 'Married',
    value: 'Married'
  },
  {
    label: 'Widowed',
    value: 'Widowed'
  },
  {
    label: 'Divorced',
    value: 'Divorced'
  },
  {
    label: 'Separated',
    value: 'Separated'
  }
];

export const GenderOption = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' }
];
